import constants from '../constants.js';

const CtmPortalProductByDebtorList = {
  rootNode: true,
  displayName: 'Debtor Ctm Portal',
  endpoint: 'DebtorProducts',
  ODataArgs: `?$select=DebtorIdentifier,Type,Enabled&$filter=Type eq '${constants.PRODUCT.CTMPORTAL}' and IsDeleted eq false`,
  displayAs: constants.DISPLAY_AS.GRID,
  iconClass: 'fa-th',
  gridCols:
    [{ name: 'Debtor', key: 'DebtorIdentifier' },
    { name: 'Product', key: 'Type' },
    { name: 'Enabled', key: 'Enabled' }]
};

const CtmMobileProductByDebtorList = {
  rootNode: true,
  displayName: 'Debtor Ctm Mobile',
  endpoint: 'DebtorProducts',
  ODataArgs: `?$select=DebtorIdentifier,Type,Enabled&$filter=Type eq '${constants.PRODUCT.CTMMOBILE}' and IsDeleted eq false`,
  displayAs: constants.DISPLAY_AS.GRID,
  iconClass: 'fa-mobile',
  gridCols:
    [{ name: 'Debtor', key: 'DebtorIdentifier' },
    { name: 'Product', key: 'Type' },
    { name: 'Enabled', key: 'Enabled' }]
};

const CtmApproveProductByDebtorList = {
  rootNode: true,
  displayName: 'Debtor Ctm Approve',
  endpoint: 'DebtorProducts',
  ODataArgs: `?$select=DebtorIdentifier,Type,Enabled&$filter=Type eq '${constants.PRODUCT.CTMAPPROVE}' and IsDeleted eq false`,
  displayAs: constants.DISPLAY_AS.GRID,
  iconClass: 'fa-thumbs-up',
  gridCols:
    [{ name: 'Debtor', key: 'DebtorIdentifier' },
    { name: 'Product', key: 'Type' },
    { name: 'Enabled', key: 'Enabled' }]
};

const CtmLightningProductByDebtorList = {
  rootNode: true,
  displayName: 'Debtor Lightning Book',
  endpoint: 'DebtorProducts',
  ODataArgs: `?$select=DebtorIdentifier,Type,Enabled&$filter=Type eq '${constants.PRODUCT.LIGHTNINGBOOK}' and IsDeleted eq false`,
  displayAs: constants.DISPLAY_AS.GRID,
  iconClass: 'fa-bolt',
  gridCols:
    [{ name: 'Debtor', key: 'DebtorIdentifier' },
    { name: 'Product', key: 'Type' },
    { name: 'Enabled', key: 'Enabled' }]
};

const CtmRideShareProductByDebtorList = {
  rootNode: true,
  displayName: 'Debtor Ride Share',
  endpoint: 'DebtorProducts',
  ODataArgs: `?$select=DebtorIdentifier,Type,Enabled&$filter=Type eq '${constants.PRODUCT.RIDESHARE}' and IsDeleted eq false`,
  displayAs: constants.DISPLAY_AS.GRID,
  iconClass: 'fa-taxi',
  gridCols:
    [{ name: 'Debtor', key: 'DebtorIdentifier' },
    { name: 'Product', key: 'Type' },
    { name: 'Enabled', key: 'Enabled' }]
};

const CtmRiskProductByDebtorList = {
  rootNode: true,
  displayName: 'Debtor Risk',
  endpoint: 'DebtorProducts',
  ODataArgs: `?$select=DebtorIdentifier,Type,Enabled&$filter=Type eq '${constants.PRODUCT.RISK}' and IsDeleted eq false`,
  displayAs: constants.DISPLAY_AS.GRID,
  iconClass: 'fa-exclamation-circle',
  gridCols:
    [{ name: 'Debtor', key: 'DebtorIdentifier' },
    { name: 'Product', key: 'Type' },
    { name: 'Enabled', key: 'Enabled' }]
};

export default {
  CtmPortalProductByDebtorList,
  CtmMobileProductByDebtorList,
  CtmApproveProductByDebtorList,
  CtmLightningProductByDebtorList,
  CtmRideShareProductByDebtorList,
  CtmRiskProductByDebtorList
}


// WEBPACK FOOTER //
// ./src/config/fields/products.js